import '@datadog/browser-rum/bundle/datadog-rum';
import datadogConfig from './datadog.config';

export const initDatadog = () => {
  (window as any).DD_RUM.init(datadogConfig);
};
